import PinYellowIcon from './component'

export default PinYellowIcon
